/**
 * /my-coaching/business/lead-magnets — the coach's Wheel of Life page and download lead
 * magnet (Assessments) and the visitors who shared their results (Leads),
 * behind `coach_wheel_pages`. Without the flag, and for a revoked coach, it
 * goes to the dashboard.
 */

import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { PageHeader } from "~/components/ui/page-title";
import { Tab, TabList } from "~/components/ui/tabs";
import { WhatsNewHereLink } from "~/components/whats-new/whats-new-here-link";
import { isFeatureFlagOn } from "~/lib/feature-flags/route";

export const Route = createFileRoute(
  "/_user/my-coaching/business/lead-magnets",
)({
  staticData: { title: "Lead magnets" },
  beforeLoad: async ({ context }) => {
    if (
      context.isRevoked ||
      !(await isFeatureFlagOn(context.queryClient, "coach_wheel_pages"))
    ) {
      throw redirect({ to: "/my-coaching/clients/dashboard" });
    }
  },
  component: LeadMagnetsLayout,
});

function LeadMagnetsLayout(): React.JSX.Element {
  return (
    <div className="max-w-4xl space-y-8">
      <TabList className="w-full">
        <Tab to="/my-coaching/business/lead-magnets" exact>
          Assessments
        </Tab>
        <Tab to="/my-coaching/business/lead-magnets/leads">Leads</Tab>
      </TabList>
      <PageHeader
        actions={<WhatsNewHereLink module="lead_magnets" />}
        description="Free resources visitors can use from your website or profile."
        title="Lead magnets"
      />
      <Outlet />
    </div>
  );
}
